import React from 'react';
import { useTranslation } from 'react-i18next';

import NoOrganisationCard from 'components/v2/empty-state/NoOrganisationCard';
import dashboardImage from 'images/dashboard.png';

const WelcomeToPortal: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <NoOrganisationCard
      icon={<img src={dashboardImage} alt="" />}
      title={t('epdDashboard.userHasNoCompanies.welcomeToPortal')}
      descriptionLines={[
        t('epdDashboard.userHasNoCompanies.startEpdPortalInfo1'),
        t('epdDashboard.userHasNoCompanies.startEpdPortalInfo2'),
      ]}
    />
  );
};

export default WelcomeToPortal;
